import { useState, useEffect } from "react";
import SEO from "../components/SEO";
import SectionOne from "../components/SectionOne";
import ImageTextBlock from "blocks/ImageTextBlock";
import Carousel from "blocks/Carousel";
import Text from "../components/Text";
import AnimatedSection from "../components/AnimatedSection";
import ProductCategories from "../components/ProductCategories";
import { getProductByHandle } from "../services/medusa/client";

// Imágenes de inicio desde public/
const inicioPhoto2 = '/images/secciones/inicio/inicio-photo-block-2.webp';
const inicioPhoto3 = '/images/secciones/inicio/inicio-photo-block-3.webp';
const diagnosticoPhoto = '/images/products/Frames-products-description/Tu_rutina_hecha_para_tu_piel_creador_de_rutinas_physiology_skincare.webp';






const descriptions = {
desc1 : 'El cuidado comienza cuando entendemos que lo suficiente es, en realidad, todo.',
diagnostico : 'Responde 9 preguntas y te armamos una rutina de mañana y noche: qué usar, en qué orden y qué días.',
desc2 : 'No hablamos solo de cosmética, sino de memoria: rituales, ciencia y arte.',
desc3 : 'Los prebióticos enseñan a la piel a recordar cómo mantenerse en calma, incluso en el ruido. Una serenidad que se cultiva molécula a molécula.',
}


// "Nuestra Selección": productos curados. La imagen se toma SIEMPRE del backend
// (thumbnail en Cloudflare R2) usando el `handle`; `name`/`desc` es el copy
// editorial de esta sección. Antes había un `fallbackImg` local por producto,
// pero esas fotos eran versiones viejas (pre-render) y se eliminaron; ahora, si
// el backend no responde, cada slide cae al placeholder transparente (BLANK_IMG)
// igual que "Novedades", en lugar de intentar cargar un archivo inexistente.
const CURATED_FAVORITES = [
  { handle: 'limpiador-a-la-miel',         name: 'Dermolimpiador a la Miel',   desc: 'Mieles vegetales que limpian suavemente la piel' },
  { handle: 'serum-vitamina-c-pura-12-20', name: 'Serum Vitamina C Pura',      desc: 'Aporta luminosidad con antioxidantes' },
  { handle: 'serum-facial-niacinamida',    name: 'Serum Facial Niacinamida',   desc: 'Ayudar a disminuir la pigmentación, refinar los poros' },
  { handle: 'retinol-05-60ml',             name: 'Serum Retinol 0.5% Antiedad', desc: 'Disminuye signos de envejecimiento' },
  { handle: 'acido-azelaico-15',           name: 'Ácido Azelaico 15%',         desc: 'Pomada para reducir afecciones cutáneas' },
  { handle: 'suncarepure-solar-70ml',      name: 'Suncare Pure SPF 50+',       desc: 'Altra protección contra los radicales libres' },
  { handle: 'restorative-hydra-cream',     name: 'Restorative Hydra Cream',    desc: 'Hidratación con protección 30 FPS' },
];

// "Nuestros últimos lanzamientos": mismo esquema que arriba. Estos productos
// no tienen imagen local, así que la imagen viene siempre del backend (R2).
const CURATED_LAUNCHES = [
  { handle: 'resurge-advance-phase-i-serum', name: 'RESURGE Advance Phase I Serum',     desc: 'Serum renovador con tres niveles de exfoliación química' },
  { handle: 'resurge-tonic-phase-2',         name: 'RESURGE TONIC Phase II',            desc: 'Una piel limpia, uniforme y con un acabado mate' },
  { handle: 'soma-lacta-phase-i-serum',      name: 'Soma Lacta Phase I Serum',          desc: 'Renueva y equilibra tu piel con una fusión avanzada' },
  { handle: 'soma-tonic-phase-ii',           name: 'SOMA Phase II – Tónico Exfoliante', desc: 'Una piel limpia, uniforme y con un acabado mate' },
  { handle: 'vitamin-c-face-mist',           name: 'Vitamin C Face Mist',               desc: 'Bruma facial para revitalizar la piel' },
  { handle: 'gotu-kola-tonic',               name: 'Gotu-Kola Leaf Tonic',              desc: 'Tonifica y prepara la piel para tu rutina' },
];

// Placeholder transparente para mantener el número de slides estable mientras
// el backend resuelve las imágenes (evita el ícono de imagen rota).
const BLANK_IMG = 'data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22/%3E';

// Resuelve una lista curada: usa el thumbnail real (R2) de cada producto por
// handle y cae al placeholder transparente si el backend no responde.
async function resolveCurated(list) {
  const products = await Promise.all(
    list.map((f) => getProductByHandle(f.handle).catch(() => null))
  );
  return list.map((f, i) => {
    const p = products[i];
    return {
      handle: f.handle,
      name: f.name,
      desc: f.desc,
      img: p?.thumbnail || p?.images?.[0]?.url || BLANK_IMG,
    };
  });
}

const textBlock = {
  block1 : {
    title:'Nuestra Selección',
    miniTitle:'Favoritos',
    para :'En Physiology pensamos que la sencillez no es ausencia, sino dominio. En cada textura hay una decisión consciente: refinar, no adornar; percibir, no distraer.',
    btn : 'Ver nuestros favoritos',
    link : '/curated-selection'
  },
  block2 : {
    title:'Nuestros últimos lanzamientos',
    miniTitle:'Novedades',
    para :'Cada lanzamiento nace de una obsesión por la textura y el activo justo: fórmulas que renuevan el ritual sin traicionar su esencia; innovar, no imitar; cuidar.',
    btn : 'Ver nuestros lanzamientos',
    link : '/shop?category=lanzamientos'
  }
}

const UE_BASE = '/images/secciones/inicio/Inicio%20Segundo%20Hero%20Slider%20seccion%20Ultimas%20ediciones';
const carousal = [
  { type: 'image', img: `${UE_BASE}/Inicio_seccion_Carusel_ultimas_ediciones_slide_1.webp` },
  { type: 'image', img: `${UE_BASE}/Inicio_seccion_Carusel_ultimas_ediciones_slide_2.webp` },
  { type: 'image', img: `${UE_BASE}/Inicio_seccion_Carusel_ultimas_ediciones_slide_3.webp` },
];


const Home = () => {
  // Estado inicial: copy curado + placeholder transparente. Antes favoritos
  // pintaba la imagen local (fallbackImg) y el useEffect la reemplazaba por el
  // render de R2, provocando un "salto" de foto vieja -> render al cargar. Ahora
  // arranca en blanco (igual que novedades) y solo se pinta el render real;
  // fallbackImg sigue usándose dentro de resolveCurated si el backend falla.
  const [favoritos, setFavoritos] = useState(() =>
    CURATED_FAVORITES.map(({ handle, name, desc }) => ({
      handle,
      name,
      desc,
      img: BLANK_IMG,
    }))
  );
  const [novedades, setNovedades] = useState(() =>
    CURATED_LAUNCHES.map(({ handle, name, desc }) => ({
      handle,
      name,
      desc,
      img: BLANK_IMG,
    }))
  );

  // Al montar: resolver ambas listas por handle y usar sus imágenes reales de R2.
  useEffect(() => {
    let alive = true;
    (async () => {
      const [fav, nov] = await Promise.all([
        resolveCurated(CURATED_FAVORITES),
        resolveCurated(CURATED_LAUNCHES),
      ]);
      if (!alive) return;
      setFavoritos(fav);
      setNovedades(nov);
    })();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <>
      <SEO
        title="Skincare minimalista mexicano · Formulando arte"
        description="Physiology Skincare Co: marca mexicana de cuidado facial minimalista desde 2017. Sérums, cremas y kits con activos de alta pureza —vitamina C, niacinamida, retinol— eficaces y con precios realistas."
        path="/"
      />
      <div data-header-theme="dark">
        {/* El hero maneja su propia entrada (espera a que cargue la media). */}
        <SectionOne />
      </div>

      <AnimatedSection delay={200}>
        <Carousel products={favoritos} block={textBlock.block1} textBlock='top-[-23rem]'/>
      </AnimatedSection>

      <div className="bg-offWhite" data-header-theme="light">
        <AnimatedSection delay={400}>
          <ImageTextBlock even={true} img={diagnosticoPhoto} title='Tu rutina, hecha para tu piel' desc={descriptions.diagnostico} btn='Haz tu diagnóstico' href='/diagnostico' />
        </AnimatedSection>

        <AnimatedSection delay={600}>
          <Carousel products={novedades} block={textBlock.block2} textBlock='top-[-27rem]'/>
        </AnimatedSection>

        <AnimatedSection delay={800}>
          <ImageTextBlock img={inicioPhoto2} title='La piel como sistema vivo' desc={descriptions.desc1} btn='Visitar tienda' href='/shop'/>
        </AnimatedSection>

        <AnimatedSection delay={900}>
          <ProductCategories />
        </AnimatedSection>

        <AnimatedSection delay={1000}>
          <ImageTextBlock even={true} title='Ultimas ediciones' desc={descriptions.desc2} btn='Visitar archivo' href='/journal' carousal={carousal}/>
        </AnimatedSection>

        <AnimatedSection delay={1200}>
          <ImageTextBlock img={inicioPhoto3} miniTitle='Facial Appointments' title='La ciencia se vuelve cuidado' desc={descriptions.desc3} btn='Conoce nuestros tratamientos' href='/shop?category=tratamientos'/>
        </AnimatedSection>

        <AnimatedSection delay={1400}>
          <Text />
        </AnimatedSection>
      </div>
    </>
  );
};

export default Home;
